import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IFormFieldState } from '../../../FormFieldSet';
import SimpleFieldHeader from '../common/SimpleFieldHeader';
import { NumberDisplay } from './NumberDisplay';
import { NumberEmptyState } from './NumberEmptyState';
import { IFormFieldNumber } from '.';
interface ISimpleNumberProps {
  formFieldState: IFormFieldState;
  config: IFormFieldNumber;
}

const SimpleNumber: React.FC<ISimpleNumberProps> = ({ formFieldState }) => {
  return (
    <Flex flexDirection="column" gap={2}>
      <SimpleFieldHeader {...formFieldState} />
      {formFieldState.value ? (
        <NumberDisplay value={Number(formFieldState.value) || 0} />
      ) : (
        <NumberEmptyState />
      )}
    </Flex>
  );
};

export default SimpleNumber;
